var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-control custom-checkbox checkbox-xl"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.isDisabled},on:{"change":_vm.change}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }